import React from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import axiosInstance from "../../../../../Services/axiosCommon";
import { NuInput, NuMobileNumber } from "../../../../../Components/Utils/Input";
import { useToast } from "../../../../../Components/Others/ToastServices";

export default function AddSupplierModal({ isOpen, onClose, onSupplierCreated }) {
  const toast = useToast();

  const formik = useFormik({
    initialValues: {
      customerType: "",
      companyName: "",
      email: "",
      phone: "",
      countryCode: "",
      website: "",
      industry: "",
      cpCountryCode: "",
      contactPerson: "",
      contactPersonMobile: "",
    },
    validationSchema: yup.object({
      companyName: yup.string().required("Company Name is required"),
      email: yup.string().email("Invalid email").required("Email is required"),
      phone: yup.string().required("Phone is required"),
      contactPerson: yup.string().required("Contact Person is required"),
      contactPersonMobile: yup.string().required("Contact Person Mobile is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      const companyName = values.companyName;
      const formData = new FormData();
      formData.append(
        "vendorDetails",
        JSON.stringify({
          customerType: values.customerType || "",
          companyName: values.companyName || "",
          email: values.email || "",
          phone: values.phone || "",
          countryCode: values.countryCode || "",
          website: values.website || "",
          industry: values.industry || "",
          cpCountryCode: values.cpCountryCode || "",
          contactPerson: values.contactPerson || "",
          contactPersonMobile: values.contactPersonMobile || "",
        })
      );

      try {
        const response = await axiosInstance.post("/vendors/new-vendor", formData);
        const createdSupplier = response.data;

        if (createdSupplier.status === true) {
          onSupplierCreated({
            label: companyName || "-",
            value: createdSupplier?.SI,
          });
          resetForm();
          onClose();
        } else {
          toast.open({
            type: "warning",
            message: "Warning",
            description: createdSupplier.msg || "Warning.",
          });
        }
      } catch (error) {
        console.error("Error creating new customer:", error);
      }
    },
  });

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-900/60 backdrop-blur-xs z-[9999] flex justify-center items-center p-3 sm:p-4">
      <div className="animate-scale-in w-[92vw] sm:w-[500px] md:w-[600px] max-w-full max-h-[85vh] bg-white p-5 sm:p-6 rounded-2xl shadow-2xl overflow-y-auto flex flex-col">
        {/* <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
      <div className="animate-scale-in w-[60%] max-h-[80vh] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll"> */}
        <h2 className="text-lg font-normal text-[12px]">Add Supplier</h2>
        <form onSubmit={formik.handleSubmit}>
          <div className="mb-4 flex flex-wrap">
            <NuInput
              type="text"
              label="Company Name"
              placeholder="Company Name"
              formik={formik}
              name="companyName"
              isRequired={true}
              width="w-full md:w-1/2 lg:w-1/2"
            />
            <NuMobileNumber
              nunCode="countryCode"
              label="Phone"
              placeholder="Phone"
              formik={formik}
              name="phone"
              isRequired={true}
              width="w-full md:w-1/2 lg:w-1/2"
              FixPosition={true}
              PortalTarget={false}
            />
            <NuInput
              type="email"
              label="Email"
              placeholder="Email"
              formik={formik}
              name="email"
              width="w-full md:w-1/2 lg:w-1/2"
              isRequired={true}
            />
            <NuInput
              type="text"
              label="Website"
              placeholder="Website"
              formik={formik}
              name="website"
              width="w-full md:w-1/2 lg:w-1/2"
            />
            <NuInput
              type="text"
              label="Contact Person"
              placeholder="Contact Person"
              formik={formik}
              isRequired={true}
              name="contactPerson"
              width="w-full md:w-1/2 lg:w-1/2"
            />
            <NuMobileNumber
              nunCode="cpCountryCode"
              label="Contact Person Mobile"
              placeholder="Contact Person Mobile"
              formik={formik}
              isRequired={true}
              name="contactPersonMobile"
              width="w-full md:w-1/2 lg:w-1/2"
              FixPosition={true}
              PortalTarget={false}
            />
          </div>
          <div className="flex justify-end">
            <button
              type="button"
              onClick={onClose}
              className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm bg-[#E6F2F2] hover:bg-gray-300 rounded-md flex items-center mr-2 text-textColor-main"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-[#048178] px-5 py-[9px] cursor-pointer outline-none border-none text-white rounded-md text-xs 2xl:text-sm flex items-center"
            >
              Add
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
